import React, {Fragment, useEffect} from "react"
import {useSelector, useDispatch} from "react-redux"

import LeftWorkSize from "../LeftWorkSize/LeftWorkSize"
import LeftWorkColor from "../LeftWorkColor/LeftWorkColor"
import LeftWorkText from "../LeftWorkText/LeftWorkText"
import LeftWorkAddText from "../LeftWorkAddText/LeftWorkAddText"
// import LeftWorkClipart from "../LeftWorkClipart/LeftWorkClipart"
import LeftWorkUpload from "../LeftWorkUpload/LeftWorkUpload"
import LeftWorkEditImage from "../LeftWorkEditImage/LeftWorkEditImage"
import LeftWorkFonts from "../LeftWorkFonts/LeftWorkFonts"
import LeftWorkOutline from "../LeftWorkOutline/LeftWorkOutline"

import {
  setLeftWorkAreaState,
  clearLeftWorkAreaState,
} from "../../../redux/actions/product2dActions"

import "./leftworkareacontainer.scss"

/**
 * Container for Left work components
 * @component
 * @example
 * return <LeftWorkAreaContainer/>
 * */

const LeftWorkAreaContainer = () => {
  const dispatch = useDispatch()
  const LWAState = useSelector(state => state.LWAState)
  const makFabric = useSelector(state => state.makFabric)
  const activeObj = useSelector(state => state.activeObj)
  const activeObjs = useSelector(state => state.activeObjs)

  useEffect(() => {
    if (makFabric) {
      switch (activeObj && activeObjs.length === 1 && activeObj.type) {
        case "size":
          dispatch(setLeftWorkAreaState("EDIT_TEXT"))
          break
        case "text":
          dispatch(setLeftWorkAreaState("EDIT_TEXT"))
          break
        case "image":
          dispatch(setLeftWorkAreaState("EDIT_IMG"))
          break
        default:
          dispatch(clearLeftWorkAreaState())
          break
      }
    }
  }, [activeObj, activeObjs.length, dispatch, makFabric])

  const renderWindow = () => (
    <Fragment>
      <LeftWorkSize active={LWAState === `SIZE`} />
      <LeftWorkColor active={LWAState === `BASE_COLOR`} />
      <LeftWorkText active={LWAState === `EDIT_TEXT`} />
      {<LeftWorkAddText active={LWAState === `ADD_TEXT`} />}
      {/*<LeftWorkClipart active={LWAState === `ADD_CLIPART`} />*/}
      <LeftWorkUpload active={LWAState === `UPLOAD`} />
      <LeftWorkEditImage active={LWAState === `EDIT_IMG`} />
      <LeftWorkColor active={LWAState === `SELECT_COLOR`} textColor={true} />
      <LeftWorkFonts active={LWAState === `SELECT_FONT`} />
      <LeftWorkOutline active={LWAState === `SELECT_OUTLINE`} />
    </Fragment>
  )

  return <div className="leftWorkAreaContainer">{renderWindow()}</div>
}

export default LeftWorkAreaContainer
